<template>
  <div class="container-fluid" style="min-width:500px" :class="{'section-loading': searchLoading}">
    <div class="hint-text">※重要提醒：使用單位條件設定時，請確保使用之正確性與正當性，並遵循業務招攬相關規範及辦法。</div>
    <div class="row">
      <div class="col-12">
        <div class="radio radio-inline">
          <input
            type="radio"
            v-model="searchType"
            id="search-type-1"
            value="1"
            @click="queryallConditions()"
          />
          <label for="search-type-1">發佈中</label>
        </div>
        <div class="radio radio-inline">
          <input type="radio" v-model="searchType" id="search-type-2" value="2" />
          <label for="search-type-2">已下架</label>
        </div>
        <hr />
      </div>
    </div>
    <div class="row" v-if="searchType==1">
      <div class="col-12" style="overflow-x:scroll;width:100%">
        <table
          v-if="releaseShow"
          class="table datatable insurance-green table-striped table-bordered"
        >
          <thead>
            <tr>
              <th
                class="sorting text-left"
                :class="(order.index==1 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting(1, tableData, order, 'title')"
              >條件名稱</th>
              <th
                class="sorting text-center"
                style="min-width: 100px;"
                :class="(order.index==2 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting(2, tableData, order, 'release_date')"
              >發佈日期</th>
              <th
                class="sorting text-center"
                style="min-width: 100px;"
                :class="(order.index==3 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting(3, tableData, order, 'takeoff_date')"
              >下架日期</th>
              <th
                class="sorting text-center"
                style="min-width: 150px;"
                :class="(order.index==4 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting(4, tableData, order, 'last_editor')"
              >申請者</th>
              <th
                class="sorting text-center"
                style="min-width: 150px;"
                :class="(order.index==5 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting(5, tableData, order, 'target')"
              >發佈對象</th>
              <th
                class="sorting text-center"
                style="min-width: 100px;"
                :class="(order.index==6 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                @click="columnSorting(6, tableData, order, 'click_rate')"
              >使用率</th>
              <th class="text-center" style="min-width: 100px;">功能</th>
            </tr>
          </thead>
          <tbody v-if="tableData.length > 0">
            <tr v-for="(row, rid) in tableData" :key="`row-${rid}`">
              <td>
                <a
                  class="pointer-cursor text-underline text-green"
                  @click="lookupCondition(rid, 'release')"
                >{{row.title}}</a>
              </td>
              <td class="text-center">{{row.release_date | dateFormat}}</td>
              <td class="text-center">{{row.takeoff_date | dateFormat}}</td>
              <td class="text-center">{{row.last_editor}}</td>
              <td class="text-center">{{row.target}}</td>
              <td class="text-center">{{row.click_rate}}%</td>
              <td class="line-height-2 text-center">
                <a @click="effectiveness(row)" class="link text-underline">成效</a>
                <br />
                <a @click="openEditModal(row)" class="link text-underline">修改</a>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td :colspan="7" class="empty-block bg-white">
                <h3 class="bg-white">查無資料</h3>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>使用率=業務員點擊人數/業務員人數</p>
    </div>
    <div class="row" v-if="searchType=='2'">
      <div class="col-12">
        <form class="form">
          <div class="form-group row">
            <label class="pl-2 text-right">月份</label>
            <div class="col-11">
              <select class="form-control form-control-inline form-short" v-model="date.start_year">
                <option
                  v-for="(y, i) in selectYearOption"
                  :value="y.value"
                  :key="`star-${i}`"
                >{{y.title}}</option>
              </select>
              <span class="text">/</span>
              <select
                type="text"
                class="form-control form-control-inline form-short"
                v-model="date.start_month"
              >
                <option
                  v-for="(m,i) in selectMonthOption"
                  :value="m.value"
                  :key="`star-${i}`"
                >{{m.title}}</option>
              </select>
              <span class="text">～</span>
              <select class="form-control form-control-inline form-short" v-model="date.end_year">
                <option
                  v-for="(y,i) in selectYearOption"
                  :value="y.value"
                  :key="`end-${i}`"
                >{{y.title}}</option>
              </select>
              <span class="text">/</span>
              <select
                type="text"
                class="form-control form-control-inline form-short"
                v-model="date.end_month"
              >
                <option
                  v-for="(m,i) in selectMonthOption"
                  :value="m.value"
                  :key="`end-${i}`"
                >{{m.title}}</option>
              </select>
              <button type="button" class="btn btn-primary mt-0" @click="submitDate">查詢</button>
            </div>
          </div>
        </form>
        <div class="row" v-if="queryTableData.length !== 0">
          <table
            v-if="offlineShow"
            class="table datatable insurance-green table-striped table-bordered"
          >
            <thead>
              <tr>
                <th
                  class="sorting text-center"
                  :class="(queryOrder.index==1 ? (queryOrder.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                  @click="columnSorting(1, queryTableData, queryOrder, 'field_name')"
                >條件名稱</th>
                <th
                  class="sorting text-center"
                  style="min-width: 100px;"
                  :class="(queryOrder.index==2 ? (queryOrder.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                  @click="columnSorting(2, queryTableData, queryOrder, 'release_date')"
                >發佈日期</th>
                <th
                  class="sorting text-center"
                  style="min-width: 100px;"
                  :class="(queryOrder.index==3 ? (queryOrder.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                  @click="columnSorting(3, queryTableData, queryOrder, 'takeoff_date')"
                >下架日期</th>
                <th
                  class="sorting text-center"
                  style="min-width: 150px;"
                  :class="(queryOrder.index==4 ? (queryOrder.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                  @click="columnSorting(4, queryTableData, queryOrder, 'last_editor')"
                >申請者</th>
                <th
                  class="sorting text-center"
                  style="min-width: 150px;"
                  :class="(queryOrder.index==5 ? (queryOrder.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                  @click="columnSorting(5, queryTableData, queryOrder, 'target')"
                >發佈對象</th>
                <th
                  class="sorting text-center"
                  style="min-width: 100px;"
                  :class="(queryOrder.index==6 ? (queryOrder.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                  @click="columnSorting(6, queryTableData, queryOrder, 'click_rate')"
                >使用率</th>
                <th class="text-center" style="min-width: 100px;">功能</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rid) in queryTableData" :key="`row-${rid}`">
                <td>
                  <a
                    class="pointer-cursor text-underline text-green"
                    @click="lookupCondition(rid, 'offline')"
                  >{{row.title}}</a>
                </td>
                <td class="text-center">{{row.release_date | dateFormat}}</td>
                <td class="text-center">{{row.takeoff_date | dateFormat}}</td>
                <td class="text-center">{{row.last_editor}}</td>
                <td class="text-center">{{row.target}}</td>
                <td class="text-center">{{row.click_rate}}</td>
                <td class="line-height-2 text-center">
                  <a @click="effectiveness(row)" class="link text-underline">成效</a>
                  <br />
                  <a class="link text-underline disabled">修改</a>
                </td>
              </tr>
            </tbody>
          </table>
          <p>使用率=業務員點擊人數/業務員人數</p>
        </div>
        <div v-else class="empty-block w-100">
          <span>無任何查詢結果。</span>
        </div>
      </div>
    </div>
    <conditional-combination-modal
      :open="conditionalCombinationOpen"
      :condition_data="condition_data"
      :modal_title="modal_title"
      :isEdit="is_edit"
      @close="panelClose('conditionalCombinationOpen')"
      @takeoff-condition="takeoffCondition"
      @change-condition="changeCondition"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DataTable from "@/components/DataTable/DataTableCollapse";
import { commonMixin } from "@/mixins/common";
import { getConditionMeesage, getConditionMeesageDetail } from "@/service";
import { queryconditions, queryoffconditions } from "@/service";

import ConditionalCombinationModal from "./ConditionalCombinationModal";

export default {
  name: "SearchList",
  mixins: [commonMixin],
  components: {
    DataTable,
    ConditionalCombinationModal
  },
  computed: {
    ...mapGetters([]),
    startDate() {
      // 計算開始日期
      return `${this.date.start_year}-${this.date.start_month}-01`;
    },
    endDate() {
      // 計算結束日期
      let lastDay =
        new Date(this.date.end_year, this.date.end_month, 0).getDate() + "";
      return `${this.date.end_year}-${this.date.end_month}-${
        lastDay.length == 1 ? "0" + lastDay : lastDay
      }`;
    }
  },
  props: {
    status: String
  },
  watch: {
    status(val) {
      if (val == "STATUS_SEARCH_LIST") {
        this.initqueryconditions();
      }
    }
  },
  data() {
    return {
      searchType: 1,
      releaseShow: true,
      offlineShow: true,
      searchLoading: false,
      order: {
        currentTable: 1,
        index: 1,
        asc: true
      },
      queryOrder: {
        currentTable: 1,
        index: 1,
        asc: true
      },
      date: {
        start_year: "",
        start_month: "",
        end_year: "",
        end_month: ""
      },
      selectYearOption: [],
      selectMonthOption: [
        { title: "1 月", value: "01" },
        { title: "2 月", value: "02" },
        { title: "3 月", value: "03" },
        { title: "4 月", value: "04" },
        { title: "5 月", value: "05" },
        { title: "6 月", value: "06" },
        { title: "7 月", value: "07" },
        { title: "8 月", value: "08" },
        { title: "9 月", value: "09" },
        { title: "10 月", value: "10" },
        { title: "11 月", value: "11" },
        { title: "12 月", value: "12" }
      ],
      tableData: [],
      queryTableData: [],
      conditionalCombinationOpen: false,
      modal_title: "條件組合明細",
      condition_data: {},
      is_edit: false
    };
  },
  methods: {
    ...mapActions(["setPageLock"]),
    changeType(val) {
      this.order.currentTable = Number(val);
    },
    columnSorting(i, table_data, order, itemName) {
      let sort_type = "";
      if (order.index == i) {
        order.asc = !order.asc;
      } else {
        order.asc = true;
      }
      if (order.asc) {
        sort_type = "asc";
      } else {
        sort_type = "desc";
      }
      order.index = i;
      if (table_data.length == 0) {
        return;
      }
      if (sort_type == "asc") {
        this.releaseShow = false;
        this.offlineShow = false;
        table_data.sort((A, B) => {
          return A[itemName] > B[itemName] ? 1 : -1;
        });
        setTimeout(() => {
          this.releaseShow = true;
          this.offlineShow = true;
          this.registerHanlink(); // for 難字
        }, 50);
      } else {
        this.releaseShow = false;
        this.offlineShow = false;
        table_data.sort((A, B) => {
          return A[itemName] < B[itemName] ? 1 : -1;
        });
        setTimeout(() => {
          this.releaseShow = true;
          this.offlineShow = true;
          this.registerHanlink(); // for 難字
        }, 50);
      }
    },
    submitDate() {
      let startY = this.date.start_year;
      let startM = this.date.start_month;
      let endY = this.date.end_year;
      let endM = this.date.end_month;

      if (
        String(startY) == "" ||
        String(startM) == "" ||
        String(endY) == "" ||
        String(endM) == ""
      ) {
        this.$toast.info({ title: "起始日期、結束日期不得為空" });
      } else {
        if (endY < startY) {
          this.$toast.info({ title: "起始日期不得超出結束日期" });
        } else {
          if (endY == startY && endM < startM) {
            this.$toast.info({ title: "起始日期不得超出結束日期" });
          } else {
            this.queryoffConditions();
          }
        }
      }

      let self = this;
      //Call Api
      // getConditionMeesage(this.start_year,this.start_month,this.end_year,this.end_month).then(result => {
      //   self.queryTableData = result;
      // });
    },
    effectiveness(item) {
      this.$emit("open-effect", "STATUS_EFFECTIVENESS", item);
    },
    openEditModal(item) {
      this.$emit("open-edit", "STATUS_EDIT_UNIT", item);
    },

    lookupCondition(index, type) {
      this.is_edit = false;
      if (type == "release") {
        this.condition_data = this.tableData[index];
      } else {
        this.condition_data = this.queryTableData[index];
      }
      this.panelOpen("conditionalCombinationOpen");
    },
    takeoffCondition(id) {
      //Call 下架api
      this.tableData = this.tableData.filter(function(item) {
        return item.id != id;
      });
    },
    changeCondition(id, release_date, takeoff_date) {
      //Call 修改api
      for (var i in this.tableData) {
        if (this.tableData[i].id == id) {
          this.tableData[i].release_date = release_date;
          this.tableData[i].takeoff_date = takeoff_date;
          break; //Stop this loop, we found it!
        }
      }
    },
    initqueryconditions() {
      this.searchLoading = true;
      this.tableData = [];
      queryconditions(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.divNo
      ).then(result => {
        this.searchLoading = false;
        if (result.header && "200" == result.header.status) {
          this.tableData = result.body.map(map => {
            return {
              title: map.devfilter_name || "",
              release_date: map.upload_date || "",
              takeoff_date: map.end_date || "",
              last_editor: map.agnt_name || "",
              target: map.target_cs || "",
              click_rate:
                Object.keys(map.percentage_list).length > 0
                  ? map.percentage_list.click_percentage
                  : "0",
              apply_date: map.applydate || "",
              option_ch: map.option_ch.split(";") || [],
              cedvnm: map.cedvnm || "",
              dev_nm: map.dev_nm || "",
              devfilter_serno: map.devfilter_serno || "",
              devno: map.devno || "",
              news_status: map.news_status || "",
              agnt_id: map.agnt_id || "",
              field_name: map.field_name || "",
              modifydate: map.modifydate || "",
              ta_count: map.ta_count || "",
              condition_status: map.condition_status || "",
              foption: map.foption || ""
            };
          });
        }
        this.registerHanlink(); // for 難字
      });
    },
    queryallConditions() {
      this.initqueryconditions();
    },
    queryoffConditions() {
      this.searchLoading = true;
      this.queryTableData = [];
      queryoffconditions(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.divNo,
        this.startDate,
        this.endDate
      ).then(result => {
        this.searchLoading = false;
        if (result.header && "200" == result.header.status) {
          this.queryTableData = result.body.map(map => {
            return {
              title: map.devfilter_name || "",
              release_date: map.upload_date || "",
              takeoff_date: map.end_date || "",
              last_editor: map.agnt_name || "",
              target: map.target_cs || "",
              click_rate:
                Object.keys(map.percentage_list).length > 0
                  ? map.percentage_list.click_percentage
                  : "0",
              apply_date: map.applydate || "",
              option_ch: map.option_ch.split(";") || [],
              cedvnm: map.cedvnm || "",
              dev_nm: map.dev_nm || "",
              devfilter_serno: map.devfilter_serno || "",
              devno: map.devno || "",
              news_status: map.news_status || "",
              agnt_id: map.agnt_id || "",
              field_name: map.field_name || "",
              modifydate: map.modifydate || "",
              ta_count: map.ta_count || "",
              condition_status: map.condition_status || "",
              foption: map.foption || ""
            };
          });
        }
        this.registerHanlink(); // for 難字
      });
    },
    initDate() {
      let nowDate = this.getCurrentDate().split("-");
      //  產生年份 select
      let endY = nowDate[0] - 1911;
      for (let i = endY; i >= 99; i--) {
        this.selectYearOption.push({ title: `${i} 年`, value: i + 1911 + "" });
      }

      //  初始化日期區間
      if (nowDate[1] - 1 > 0) {
        this.date.start_year = nowDate[0];
        this.date.end_year = nowDate[0];
        this.date.start_month =
          (nowDate[1] - 1 + "").length == 1
            ? "0" + (nowDate[1] - 1 + "")
            : nowDate[1] - 1 + "";
        this.date.end_month =
          (nowDate[1] - 1 + "").length == 1
            ? "0" + (nowDate[1] - 1 + "")
            : nowDate[1] - 1 + "";
      } else {
        this.date.start_year = nowDate[0] - 1 + "";
        this.date.end_year = nowDate[0] - 1 + "";
        this.date.start_month =
          (nowDate[1] - 1 + 12 + "").length == 1
            ? "0" + (nowDate[1] - 1 + 12 + "")
            : nowDate[1] - 1 + 12 + "";
        this.date.end_month =
          (nowDate[1] - 1 + 12 + "").length == 1
            ? "0" + (nowDate[1] - 1 + 12 + "")
            : nowDate[1] - 1 + 12 + "";
      }
    }
  },
  mounted() {
    this.initqueryconditions();

    this.initDate();
  }
};
</script>
<style lang="scss" scoped>
  .hint-text {
    font-size: 22px;
    font-weight: 600;
    color: red;
    padding-bottom: 10px;
  }
</style>
